import React, { useCallback } from 'react';
import Checkbox from '@mui/material/Checkbox';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { NotPrimaryIcon, PrimaryIcon } from '@/assets/images';
import CustomLink from '@/components/common/CustomLink';

function PrimaryCheckbox({
  className,
  primary,
  onChange,
  label,
  checkboxProps,
  ...rest
}) {
  const toggleState = useCallback(
    () => onChange(!primary),
    [onChange, primary],
  );

  return (
    <div className={classNames(className, 'flex items-center')} {...rest}>
      {Boolean(label) && (
        <CustomLink onClick={toggleState} className="mr-2">
          {label}
        </CustomLink>
      )}
      <Checkbox
        className="p-0"
        checked={primary}
        checkedIcon={<PrimaryIcon />}
        icon={<NotPrimaryIcon />}
        onChange={toggleState}
        {...checkboxProps}
      />
    </div>
  );
}

PrimaryCheckbox.propTypes = {
  className: PropTypes.string,
  checkboxProps: PropTypes.shape({}),
  primary: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
};

PrimaryCheckbox.defaultProps = {
  checkboxProps: {},
  className: '',
  label: '',
};

export default PrimaryCheckbox;
